import { ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';

export const AuthRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild([]);
